<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { provide } from "vue";
import dayjs from "dayjs";
import checkVersion from "./utils/versionCheck";

export default {
  setup() {
    provide("dayjs", dayjs);
  },
  mounted() {
    // Initial check for version
    checkVersion(this.$toast);

    // Poll every 5 minutes
    this.versionInterval = setInterval(
      () => {
        checkVersion(this.$toast);
      },
      5 * 60 * 1000,
    );

    // Check version whenever we change routes to avoid chunk errors
    this.$router.afterEach(() => {
      checkVersion(this.$toast);
    });
  },
  beforeUnmount() {
    if (this.versionInterval) {
      clearInterval(this.versionInterval);
    }
  },
};
</script>
